import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ActivityType } from 'course-types';

interface ACTIVITY_STATE_TYPE {
  id: string | undefined;
  type: ActivityType;
  name: string;
  description: string | undefined;
  index: number;
  url: string | undefined;
}

const INITIAL_STATE: ACTIVITY_STATE_TYPE = {
  id: undefined,
  name: '',
  description: undefined,
  type: 'Chat',
  index: -1,
  url: undefined,
};

const activitySlice = createSlice({
  name: 'activity',
  initialState: INITIAL_STATE,
  reducers: {
    setActivityId(state: ACTIVITY_STATE_TYPE, action: PayloadAction<string | undefined>) {
      state.id = action.payload;
    },
    setActivityName(state: ACTIVITY_STATE_TYPE, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    setActivityDescription(state: ACTIVITY_STATE_TYPE, action: PayloadAction<string | undefined>) {
      state.description = action.payload;
    },
    setActivityType(state: ACTIVITY_STATE_TYPE, action: PayloadAction<ActivityType>) {
      state.type = action.payload;
    },
    setActivityIndex(state: ACTIVITY_STATE_TYPE, action: PayloadAction<number>) {
      state.index = action.payload;
    },
    setActivityURL(state: ACTIVITY_STATE_TYPE, action: PayloadAction<string | undefined>) {
      state.url = action.payload;
    },
    resetActivitySlice(state: ACTIVITY_STATE_TYPE) {
      state.id = INITIAL_STATE.id;
      state.name = INITIAL_STATE.name;
      state.description = INITIAL_STATE.description;
      state.type = INITIAL_STATE.type;
      state.index = INITIAL_STATE.index;
      state.url = INITIAL_STATE.url;
    },
  },
});

export const {
  setActivityId,
  setActivityType,
  setActivityName,
  setActivityDescription,
  setActivityIndex,
  setActivityURL,
  resetActivitySlice,
} = activitySlice.actions;

export default activitySlice.reducer;
